import attack from '@/request/request'
import { BASIC } from '@/data/requers_variable'

export default {
  /**
   * 专家库列表
   * 
   * @param {any} params 
   * @returns 
   */
  export_list(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/expert/search/client`,
        data: params,
        success(rep) {
          resolve(rep.data)
        },
        error(err) {
          reject({
            msg: err.message,
            status: false,

          })
        }
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/data/basic/manage/expert.js